import { Component } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { CompanyInfo, CompanyService } from '../../../services/company.service'

@Component({
  selector: 'app-company-confirm',
  templateUrl: './company-confirm.component.html',
  styleUrls: ['./company-confirm.component.scss'],
})
export class CompanyConfirmComponent {
  company: CompanyInfo | null = null
  constructor(
    private companyService: CompanyService,
    private router: Router,
  ) {}
  ngOnInit(): void {
    this.company = this.companyService.SelectedCompany
    if (this.company === null) {
      this.router.navigate(['/company-search'])
    }
  }
  goBack() {
    this.router.navigate(['/company-search'])
  }

  goNext() {
    console.log('次へ進む')
    this.router.navigate(['/registration-confirm'])
  }
}
